import type { GraphEdgesSettings } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectAllEdgesSettings: (s: GraphState) => GraphEdgesSettings =
  createScopedSelector(() =>
    createSelector(
      (s) => s.layoutSettings.preset.edges,
      (s) => s.pathlookup.preset.edges,
      (topologyEdges, pathlookupEdges) => [
        ...topologyEdges,
        ...pathlookupEdges,
      ],
    ),
  );
